@if (record._id && comment.id) {
  <div class="modal fade" id="edit-comment-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Comment</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form #editCommentForm="ngForm">
            <div class="form-group">
              <textarea class="form-control" rows="5" name="text" [(ngModel)]="comment.text" placeholder="Write your comment here..." required></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updateComment(record)"
            [disabled]="!editCommentForm.form.valid">
            <i class="fa fa-floppy-o"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
}
